var singlePurchase = document.querySelector('.product-page-add')
var currantVariantId
if (singlePurchase) {
  currantVariantId = singlePurchase.dataset.purchaseId
}
var currentPrice
let isLandingPage = document.querySelector('.landing-page')

// variant button selectors

if (document.querySelector('.variant-buttons')) {
  var variants = document.querySelectorAll('.variant-buttons .badge')
  variants.forEach(variant => {
    variant.addEventListener('click', () => {
      let isWithOptions = variant.closest('.with-options')
      let currentVariant
      let currentPrice = null
      let currentUnitPrice = null
      let inStock = true
      let currentSubPrice = null

      if (isWithOptions) {
        isWithOptions.querySelectorAll('.variant-buttons .badge').forEach(v => v.classList.remove('current'))
        variant.classList.add('current')
        var currentSelection = []
        // build an array of currently selected options
        document.querySelectorAll('.variant-buttons .badge.current').forEach(option => {
          currentSelection.push(option.dataset.variantName)
        })
        console.log('currentSelection', currentSelection)
        var data = JSON.parse(document.querySelector('#variant-json').textContent)

        data.forEach(variant => {
          var variantOptions = variant.options
          var isEqual = variantOptions.length === currentSelection.length && variantOptions.every(val => currentSelection.includes(val))
          if (isEqual) {
            console.log('found matching variant', variant)
            currentVariant = variant.variant
            currentPrice = variant.price
            inStock = variant.stock
            currentSubPrice = variant.subscription_price
          }
        })
      } else {
        variants.forEach(variant => variant.classList.remove('current'))
        variant.classList.add('current')

        currentVariant = variant.dataset.variantId
        currentPrice = variant.dataset.variantPrice
        currentSubPrice = variant.dataset.variantSubscriptionPrice

        if (variant.dataset.unitPrice) currentUnitPrice = variant.dataset.unitPrice
      }
      updateVariant(currentPrice, currentVariant, currentUnitPrice, inStock, currentSubPrice)
      changeToImage(currentVariant, true)
    })
  })
}

// variant dropdown selectors

function dropdownVariants(recentlyChanged) {
  var currentSelection = []
  // build an array of currently selected options
  var optionDropdowns = document.querySelectorAll('.product-option-dropdown').forEach(select => {
    currentSelection.push(select.value)
  })
  var data = JSON.parse(document.querySelector('#variant-json').textContent)
  var matchingVariant = false
  var matchingVariantPrice
  var matchingVariantStock
  data.forEach(variant => {
    var variantOptions = variant.options
    var isEqual = variantOptions.length === currentSelection.length && variantOptions.every(val => currentSelection.includes(val))
    if (isEqual) {
      matchingVariant = variant.variant
      matchingVariantPrice = variant.price
      matchingVariantStock = variant.stock
    }
  })
  if (matchingVariant && matchingVariantStock > 0) {
    singlePurchase.classList.remove('disabled')
    updateVariant(matchingVariantPrice, matchingVariant)
  } else {
    singlePurchase.classList.add('disabled')
    singlePurchase.innerHTML = `Out of stock`
  }
}

if (document.querySelector('#variant-json')) {
  // first run
  document.querySelectorAll('.dropdown-product-container .product-option-dropdown').forEach(select => {
    select.addEventListener('change', e => {
      let recentlyChanged = e.currentTarget.value
      dropdownVariants(recentlyChanged)
    })
  })
}

// gestures
let pageWidth = window.innerWidth || document.body.clientWidth
let treshold = Math.max(1, Math.floor(0.01 * pageWidth))
let touchstartX = 0
let touchstartY = 0
let touchendX = 0
let touchendY = 0
const limit = Math.tan(((45 * 1.5) / 180) * Math.PI)
const gestureZone = document.querySelector('.product-image-large')

// change product image from thumbnails
if (document.querySelector('.product-page-thumbnails')) {
  // hide variant thubmbnails except the first option
  document.querySelectorAll('img[data-for-variant]:not(:first-of-type)').forEach(thumbnail => {
    thumbnail.classList.add('hide')
  })
  document.querySelector('.product-page-thumbnails').addEventListener('click', e => {
    if (e.target.dataset.productImage) {
      changeToImage(e.target.dataset.imageVariant)
    }
  })

  // arrow events
  document.querySelector('#gallery-left').addEventListener('click', e => {
    e.preventDefault()
    e.stopPropagation()
    // get previous image
    let currentImage = document.querySelector('.product-page-thumbnails img.current')
    // Find the previous visible image
    let previousImage = currentImage.previousElementSibling
    while (previousImage && previousImage.classList.contains('hide')) {
      previousImage = previousImage.previousElementSibling
    }

    // If no previous visible image found, wrap to the last visible image
    if (!previousImage) {
      previousImage = currentImage.parentElement.lastElementChild
      while (previousImage && previousImage.classList.contains('hide')) {
        previousImage = previousImage.previousElementSibling
      }
    }

    // Click the found image
    if (previousImage) {
      previousImage.click()
    }
  })

  document.querySelector('#gallery-right').addEventListener('click', e => {
    e.preventDefault()
    e.stopPropagation()
    // get current image
    let currentImage = document.querySelector('.product-page-thumbnails img.current')
    // Find the next visible image
    let nextImage = currentImage.nextElementSibling
    while (nextImage && nextImage.classList.contains('hide')) {
      nextImage = nextImage.nextElementSibling
    }

    // If no previous visible image found, wrap to the last visible image
    if (!nextImage) {
      nextImage = currentImage.parentElement.firstElementChild
      while (nextImage && nextImage.classList.contains('hide')) {
        nextImage = nextImage.nextElementSibling
      }
    }

    // Click the found image
    if (nextImage) {
      nextImage.click()
    }
  })

  // gestures

  gestureZone.addEventListener(
    'touchstart',
    function (event) {
      touchstartX = event.changedTouches[0].screenX
      touchstartY = event.changedTouches[0].screenY
    },
    false
  )

  gestureZone.addEventListener(
    'touchend',
    function (event) {
      touchendX = event.changedTouches[0].screenX
      touchendY = event.changedTouches[0].screenY
      handleGesture(event)
    },
    false
  )

  function handleGesture(e) {
    let x = touchendX - touchstartX
    let y = touchendY - touchstartY
    let xy = Math.abs(x / y)
    let yx = Math.abs(y / x)
    if (Math.abs(x) > treshold || Math.abs(y) > treshold) {
      if (yx <= limit) {
        if (x < 0) {
          document.querySelector('#gallery-right').click()
        } else {
          document.querySelector('#gallery-left').click()
        }
      }
    }
  }
}

function changeToImage(id, isVariantSwitch = false) {
  let thumbnailImage = document.querySelector(`.product-page-thumbnails img[data-image-variant="${id}"]`)
  let mainImage = document.querySelector('.product-page-image')
  document.querySelectorAll('.product-page-thumbnails img').forEach(thumbnail => thumbnail.classList.remove('current'))

  if (isVariantSwitch) {
    let variantImages = document.querySelectorAll(`.product-page-thumbnails img[data-for-variant]`)
    variantImages.forEach(thumbnail => {
      if (thumbnail.dataset.imageVariant == id) {
        thumbnail.classList.remove('hide')
      } else {
        thumbnail.classList.add('hide')
      }
    })
  }

  if (thumbnailImage) {
    thumbnailImage.classList.add('current')
    mainImage.src = thumbnailImage.src
    mainImage.src = thumbnailImage.dataset.productImage

    const rect = thumbnailImage.getBoundingClientRect()
    const isVerticallyVisible = rect.top >= 0 && rect.bottom <= window.innerHeight
    if (isVerticallyVisible) thumbnailImage.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })

    // if there's an ingredients panel and it's a variant switch, switch that image too
    if (document.querySelector('.ingredients-panel-image-container') && id.length > 2 && !document.querySelector('[data-variant-name="Orange"]')) {
      document.querySelector('.ingredients-panel-image-container img').src = thumbnailImage.dataset.productImage
    }
  }
}

// subscription radio buttons

if (document.querySelector('.subscription-radio-option')) {
  let radioButtons = document.querySelectorAll('.subscription-radio-option')
  radioButtons.forEach(radioButton => {
    radioButton.addEventListener('click', e => {
      radioButtons.forEach(r => r.querySelector('.radio-button').classList.remove('selected'))
      radioButton.querySelector('.radio-button').classList.add('selected')
      // if subscription, change the functionality
      if (radioButton.id === 'select-subscription') {
        singlePurchase.dataset.subscription = 'true'
        document.querySelectorAll('.show-for-subscription').forEach(usp => usp.classList.remove('hide'))
        document.querySelectorAll('.show-for-single-purchase').forEach(usp => usp.classList.add('hide'))
      } else {
        singlePurchase.dataset.subscription = 'false'
        document.querySelectorAll('.show-for-subscription').forEach(usp => usp.classList.add('hide'))
        document.querySelectorAll('.show-for-single-purchase').forEach(usp => usp.classList.remove('hide'))
      }
    })
  })
}

// subscription dropdown change text
if (document.querySelector('.subscribe-dropdown')) {
  document.querySelector('.subscribe-dropdown .product-option-dropdown').addEventListener('change', e => {
    let newText = e.target.selectedOptions[0].text
    document.querySelector('#select-subscription .purchase-type strong').textContent = newText
    document.getElementById('select-subscription').click()
  })
}

// update price and button on variant change

function updateVariant(price, id, unitPrice, inStock = true, currentSubPrice = null) {
  document.querySelector('.current-price.one-time-price').textContent = price
  if (unitPrice) document.querySelector('.unit-price').textContent = unitPrice
  singlePurchase.dataset.purchaseId = id
  // add price to data attribute
  let pricebox_element = document.querySelector('.product-page-pricebox')
  pricebox_element.setAttribute('data-price', price.replace(',', '.').replace(`${currentCurrency}`, ''))

  if (currentSubPrice && document.querySelector('.current-price.subscription-price .sale')) {
    document.querySelector('.current-price.subscription-price .sale').textContent = currentSubPrice
    document.querySelector('.product-page-pricebox').setAttribute('data-subscription-price', currentSubPrice.replace(',', '.').replace(`${currentCurrency}`, ''))
  }

  // try to fudge price
  fudge_pricebox()

  if (!inStock) {
    console.log('out of stock combination!')
  }

  singlePurchase.textContent = 'Add to cart'
  singlePurchase.style.backgroundColor = ''
}

// quantity controls

if (document.querySelector('.product-page-quantity-selection')) {
  var adjustment = document.querySelectorAll('.product-page-quantity-selection')
  adjustment.forEach(variantQuantity => {
    variantQuantity.addEventListener('click', e => {
      let quantityInput = variantQuantity.querySelector('.quantity-number')
      var currentValue = parseInt(quantityInput.value)
      var clicked = e.target.classList
      var newValue
      switch (true) {
        case clicked.contains('quantity-minus'):
          quantityInput.value = Math.max(currentValue - 1, 0)
          newValue = quantityInput.value
          break
        case clicked.contains('quantity-plus'):
          quantityInput.value = currentValue + 1
          newValue = quantityInput.value
          break
      }
      fudge_pricebox()
    })
  })
}

// add to cart function

if (isLandingPage) {
  document.querySelector('.variant-container').style.display = 'none'
  document.querySelector('.current-price.one-time-price').innerHTML = `<span class="sale">£49.99<del>£92.16</del></span>`
}

if (singlePurchase) {
  singlePurchase.addEventListener('click', e => {
    let originalText = singlePurchase.textContent
    var quantity = document.querySelector('.product-page-quantity-selection .quantity-number').value
    let subscription = null
    if (singlePurchase.dataset.subscription === 'true') {
      subscription = document.querySelector('.product-option-dropdown').value
    }
    if (!isLandingPage) {
      singlePurchase.textContent = 'Adding…'
      let properties = {}
      if (document.querySelector('#gift-form')) {
        const giftForm = document.querySelector('#gift-form')
        if (!giftForm.checkValidity()) {
          giftForm.reportValidity()
          giftForm.querySelector('input:invalid, textarea:invalid').scrollIntoView({ behavior: 'smooth', block: 'center' })
          singlePurchase.textContent = originalText
          return
        }

        // Collect form data from all inputs with values
        const formInputs = giftForm.querySelectorAll('input, textarea')
        formInputs.forEach(input => {
          if (input.value.trim()) {
            // Convert datetime-local to ISO 8601 for Recharge
            if (input.id === '__rc_gift_notification_scheduled_at' && input.value) {
              properties[input.id] = `${input.value}:00`
            } else {
              properties[input.id] = input.value
            }
          }
        })
      }
      cartAdd(singlePurchase.dataset.purchaseId, quantity, subscription, properties)
        .then(response => {
          if (response.status == 422) {
            singlePurchase.textContent = 'Not enough stock'
            singlePurchase.style.backgroundColor = 'red'
            throw new Error('Not enough stock')
          } else {
            return updateCart()
          }
        })
        .then(() => {
          singlePurchase.textContent = originalText
          toggleElement(cartDrawer, e)
        })
    } else {
      let cartAdd = items => {
        var config = getDefaultRequestConfig()

        config.method = 'POST'
        config.body = JSON.stringify(items)

        return fetchJSONPromise(`${window.Shopify.routes.root}cart/add.js`, config)
      }
      // clear cart
      cartClear().then(() => {
        // add to cart
        let newCart = {
          items: [
            {
              id: '41104320593954',
              quantity: 1,
            },
            {
              id: '41104324263970',
              quantity: 2,
            },
            {
              id: '41079482679330',
              quantity: 1,
            },
          ],
        }
        cartAdd(newCart).then(response => {
          if (response.status == 422) {
            singlePurchase.textContent = 'Not enough stock'
            singlePurchase.style.backgroundColor = 'red'
          } else {
            // go to checkout
            window.location.href = `${window.Shopify.routes.root}checkout`
          }
        })
      })
    }
  })
}

// scroll to reviews
if (document.getElementById('badge-ribbon') && document.getElementById('ReviewsWidget')) {
  document.getElementById('badge-ribbon').addEventListener('click', () => {
    document.getElementById('ReviewsWidget').parentElement.scrollIntoView({ behavior: 'smooth' })
  })
}

// out of stock notification popup

if (document.querySelector('.stock-notification')) {
  document.querySelector('.stock-notification').addEventListener('click', e => {
    var button = e.target

    let data = {
      message: button.dataset.message,
      product: button.dataset.product,
      button: 'Notify me',
      image: button.dataset.image,
    }
    stockForm.style.opacity = '1'
    populateEmailPopup(data, e)
  })
}

// tabs functionality

var isMediaSmall = window.matchMedia('(max-width: 49.9375em)')

var tabsHaveMoved = false
var tabContainer = document.querySelector('.tab-texts-container')

if (tabContainer) {
  document.querySelector('.product-tabs-list').addEventListener('click', e => {
    var clickedTab = e.target
    var clickedTabNumber = e.target.dataset.tab
    if (clickedTab.classList.contains('product-tab-heading')) {
      // on desktop, move tabs back responsivelly if moved for mobile layout
      if (!isMediaSmall.matches && tabsHaveMoved == true) {
        document.querySelector('#desktop-tabs-location').appendChild(tabContainer)
        tabsHaveMoved = false
      }
      if (!clickedTab.classList.contains('open')) {
        document.querySelectorAll('.product-tab-heading').forEach(tab => {
          if (tab == clickedTab) {
            tab.classList.add('open')
            if (isMediaSmall.matches) {
              tab.parentNode.insertBefore(tabContainer, tab.nextSibling)
              const y = tab.getBoundingClientRect().top + window.pageYOffset - 160
              window.scrollTo({ top: y, behavior: 'smooth' })
              tabsHaveMoved = true
            }
          } else {
            tab.classList.remove('open')
          }
        })
        // find the tab content and show it
        document.querySelectorAll('.tab-content').forEach(tabContent => {
          if (tabContent.dataset.tab == clickedTabNumber) {
            tabContent.classList.add('open')
          } else {
            tabContent.classList.remove('open')
          }
        })
      }
    }
  })
}

// Ingredients modal popup (optional) – installed mainly for welcome-kit page

document.querySelectorAll('#toggle-product-ingredients-modal, .toggle-product-ingredients-popup').forEach(button => {
  button.addEventListener('click', e => {
    toggleElement(document.querySelector('#product-ingedients-modal'), e)
  })
})

// Delivery Window Calculator

// first run

deliveryTimer()

addEventListener('DOMContentLoaded', () => {
  fudge_pricebox()
})

// update every minute

setInterval(function () {
  deliveryTimer()
}, 60 * 1000)

function deliveryTimer() {
  // contains final data
  var deliveryContent = {}

  var documentDay = document.querySelector('.delivery-prompt .day')
  var documentWindow = document.querySelector('.delivery-prompt .window')

  // date object

  var now = new Date()
  var currentDay = now.getDay()
  var deliveryDeadline = new Date().setHours(14, 00, 00)

  // relative dates
  var tomorrow = new Date(new Date().setDate(new Date().getDate() + 1))
  var dayAfterTomorrow = new Date(new Date().setDate(new Date().getDate() + 2))
  var inThreeDays = new Date(new Date().setDate(new Date().getDate() + 3))

  var mondayDispatch = function () {
    deliveryContent.deliveryDay = 'Tuesday'
    deliveryContent.deadlineWindow = ' Order before Monday at 2pm'

    var nextTuesday = new Date()
    nextTuesday.setDate(nextTuesday.getDate() + ((2 + 7 - nextTuesday.getDay()) % 7))

    var nextWednesday = new Date()
    nextWednesday.setDate(nextWednesday.getDate() + ((3 + 7 - nextWednesday.getDay()) % 7))
  }

  // is it before 2pm
  if (now < deliveryDeadline) {
    // is it Monday – Friday
    if (currentDay > 0 && currentDay < 6) {
      //deliveryDeadline is today before 2pm, deliveryWindow is tomorrow

      let deadline = (deliveryDeadline - now) / 1000 / 60 / 60 // in hours
      let deadlineRemainder = 60 * (deadline - Math.floor(deadline)) // in minutes

      deliveryContent.deliveryDay = new Intl.DateTimeFormat('en-GB', {
        weekday: 'long',
      }).format(tomorrow)
      deliveryContent.deadlineWindow = ' Order within ' + Math.floor(deadline) + ' hrs ' + Math.floor(deadlineRemainder) + ' min'
    } else {
      // it's a Saturday or Sunday before 2pm
      //deliveryDeadline is Monday 2pm, deliveryWindow is Tuesday

      mondayDispatch()
    }

    // it's after 2pm
  } else {
    // is it Monday – Thursday
    if (currentDay > 0 && currentDay < 5) {
      let tomorrow2pm = new Date(new Date().setDate(new Date().getDate() + 1)).setHours(14, 00, 00)
      var dayAfterTomorrow = new Date(new Date().setDate(new Date().getDate() + 2))

      // deliveryDeadline tomrrow before 2pm, deliveryWindow is in 2 days

      let deadline = (tomorrow2pm - now) / 1000 / 60 / 60 // in hours
      let deadlineRemainder = 60 * (deadline - Math.floor(deadline)) // in minutes

      deliveryContent.deliveryDay = new Intl.DateTimeFormat('en-GB', {
        weekday: 'long',
      }).format(dayAfterTomorrow)
      deliveryContent.deadlineWindow = ' Order within ' + Math.floor(deadline) + ' hrs ' + Math.floor(deadlineRemainder) + ' min'
    } else {
      // it's after 2pm on Friday, Saturday or Sunday
      //deliveryDeadline is Monday 2pm, deliveryWindow is Tuesday
      deliveryContent.deliveryDay = 'Tuesday'
      deliveryContent.deadlineWindow = ' Order before Monday at 2pm'

      mondayDispatch()
    }
  }

  if (documentDay && documentWindow) {
    documentDay.textContent = deliveryContent.deliveryDay
    documentWindow.textContent = deliveryContent.deadlineWindow
  }
}

let cached_pricebox_deals_response_text
async function fudge_pricebox() {
  if (!isLandingPage) {
    // get deals
    if (!cached_pricebox_deals_response_text) {
      let pricebox_deals_response = await fetch('/apps/deals/all_deals.php')
      cached_pricebox_deals_response_text = await pricebox_deals_response.text()
    }
    // no deals for EU
    let deals = currentCurrency !== '£' ? [] : JSON.parse(cached_pricebox_deals_response_text)

    // fix deals structure
    deals.forEach(deal => {
      deal.products.forEach(product => {
        let product_parts = product.id.split('/')
        product.id = product_parts[product_parts.length - 1]
      })
    })

    let pricebox_element = document.querySelector('.product-page-pricebox')
    let price_element = pricebox_element.querySelector('.current-price.one-time-price .sale') ?? pricebox_element.querySelector('.current-price.one-time-price')
    let subscription_price_element = pricebox_element.querySelector('.current-price.subscription-price .sale')
    let del_element = pricebox_element.querySelector('.pricing-element-1 del')
    let upsell_element = pricebox_element.querySelector('.product-delivery-info.targeted')
    let product_id = pricebox_element.getAttribute('data-product-id')

    let quantity = 0
    let servings = 0
    for (let variant_element of document.querySelectorAll('.variant-container')) {
      let variant_quantity = Math.max(Number(variant_element.querySelector('.quantity-number').value), 0)
      let variant_serving_size = Number(variant_element.querySelector('span').textContent.split(' of ')[1] ?? 0)
      // add this in a different place for subscription page layout
      if (variant_element.querySelector('.subscription-unit-price')) {
        variant_serving_size = Number(variant_element.querySelector('.subscription-unit-price').dataset.variant.split(' of ')[1] ?? 0)
      }
      quantity += variant_quantity
      servings += variant_quantity * variant_serving_size
    }

    // spoof quantity one otherwise it's silly
    quantity = Math.max(quantity, 1)

    // check to see if servings/boxes are active
    if (quantity && !servings) servings = null

    // first run
    if (!pricebox_element.hasAttribute('data-price')) {
      pricebox_element.setAttribute('data-price', price_element.textContent.replace(',', '.').replace(`${currentCurrency}`, ''))
      if (del_element) {
        pricebox_element.setAttribute('data-presale-price', del_element.textContent.replace(',', '.').replace(`${currentCurrency}`, '').trim())
      }
    }

    // subscription first run
    if (!pricebox_element.hasAttribute('data-subscription-price') && subscription_price_element) {
      pricebox_element.setAttribute('data-subscription-price', subscription_price_element.textContent.replace(',', '.').replace(`${currentCurrency}`, ''))
    }

    let price = Number(pricebox_element.getAttribute('data-price'))
    let presale_price = Number(pricebox_element.getAttribute('data-presale-price'))

    // get subelements and attribute values
    let true_price = 0
    let true_subscription_price = 0
    let undiscounted_price = 0

    function add_line_item(discount_ratio = 1, discount_text = '', max = false) {
      // update price
      true_price += price * discount_ratio
      undiscounted_price += presale_price || price

      // update dom
      if (undiscounted_price !== true_price) {
        if (!del_element) {
          // upgrade dom to sale layout
          let container = price_element
          container.textContent = ''
          del_element = document.createElement('del')
          price_element = document.createElement('span')
          price_element.classList.add('sale')
          container.append(price_element, del_element)
        }
        del_element.textContent = currentCurrency + fix_number(undiscounted_price)
      } else if (del_element) {
        // revert dom layout
        del_element.remove()
        del_element = undefined
        price_element.remove()
        price_element = pricebox_element.querySelector('.current-price.one-time-price')
      }

      // handle subscription price
      if (subscription_price_element) {
        let subscription_price = Number(pricebox_element.getAttribute('data-subscription-price'))
        true_subscription_price += subscription_price
        document.querySelector('.current-price.subscription-price del').textContent = currentCurrency + fix_number(undiscounted_price)
        subscription_price_element.textContent = currentCurrency + fix_number(true_subscription_price)
      }

      price_element.textContent = currentCurrency + fix_number(true_price, false)

      // update upsell
      if (discount_text) upsell_element.textContent = discount_text
    }

    // find deal and create item counts (instead of groups like normal)
    let item_counts = [0]
    let deal = deals.find(deal => deal.products.some(product => product.id === product_id))
    if (deal) {
      // sort into groups/counts
      let quantity_to_add = quantity
      while (quantity_to_add--) {
        found_item_group = false

        if (
          deal.type == 'stacking' ||
          item_counts[item_counts.length - 1] < deal.product_count // either stacking (so no limit) or below limit
        ) {
          item_counts[item_counts.length - 1]++
          found_item_group = true
        }

        // add into new group if none found
        if (!found_item_group) {
          item_counts.push(1)
        }
      }

      // calculate discounts
      item_counts.forEach(item_count => {
        for (let item_index = 0; item_index < item_count; item_index++) {
          // set discount ratio and text (for applied deals only) if group reached product count
          let discount_ratio = 1
          let discount_text = ''
          let max = false
          if (item_count >= deal.product_count) {
            if (deal.type == 'bogof') {
              // no of items discounted minus position from start of group
              discount_ratio = 1 - Math.min(Math.max(deal.discount - item_index, 0), 1)

              // bogof active so show deal name
              discount_text = deal.friendly_type

              max = true
            } else if (deal.type == 'stacking') {
              // set discount based off deal discount, stacking limit, group count
              discount_ratio = 1 - deal.discount * Math.min(item_count, deal.stacking_limit)
            }
          }

          // set generic and unapplied discount text
          if (!discount_text) {
            if (deal.type == 'bogof') {
              // buy one get one free
              if (deal.product_count == 2 && deal.discount == 1) {
                discount_text = 'Add 1 for free?'

                // buy one get one half price
              } else if (deal.product_count == 2 && deal.discount == 0.5) {
                discount_text = 'Buy 1 get 1 half price '

                // 3 for 2
              } else if (deal.product_count == 3 && deal.discount == 1) {
                discount_text = 'Add more, get 3 for 2'
              }
            } else if (deal.type == 'stacking') {
              // round to .5s via *2)/2
              if (item_count >= deal.stacking_limit) {
                discount_text = Math.trunc(0.0001 + (1 - discount_ratio) * 100 * 2) / 2 + '% discount applied'
                max = true
              } else {
                discount_text = 'Buy ' + (item_count + 1) + ', get ' + Math.trunc(0.0001 + deal.discount * 100 * (item_count + 1) * 2) / 2 + '% off'
              }
            }
          }

          // add to line items
          add_line_item(discount_ratio, discount_text, max)
        }
      })
    } else {
      // add remaining (ungrouped) line items - stripped out version of above
      for (let i = 0; i < quantity; i++) {
        add_line_item()
      }
    }

    if (servings !== null) {
      let type = document.querySelector('.unit-price-1').textContent.includes('box') ? ' box' : ' tube'
      document.querySelector('.unit-price-1').textContent = quantity + type + (quantity > 1 ? (type == ' box' ? 'es' : 's') : '') + ' / ' + servings + ' servings'
      document.querySelector('.unit-price-2').textContent = currentCurrency + fix_number(true_price / servings) + ' per unit'
    }
  }
}
